// TES-201 — the analytes' readable Swedish names, keyed by the stable
// `analyteKey` (panel.v1). They mirror the mobile `labs.analytes.*` bundle so
// the doctor reads the names the patient sees. TES-1058 moved them here from
// the admin so the journal note (written by the API) names a value the same
// way the lab-feedback surface does.
export const LAB_ANALYTE_NAMES: Readonly<Record<string, string>> = {
  hba1c: "Långtidsblodsocker (HbA1c)",
  fasting_glucose: "Fasteblodsocker",
  tsh: "TSH (sköldkörtel)",
  ldl_cholesterol: "LDL-kolesterol",
  hdl_cholesterol: "HDL-kolesterol",
  triglycerides: "Triglycerider",
  alat: "ALAT (levervärde)",
  creatinine: "Kreatinin (njurvärde)",
  vitamin_d: "D-vitamin",
  ferritin: "Ferritin (järndepå)",
  vitamin_b12: "B12-vitamin",
  hemoglobin: "Hemoglobin (Hb)",
  // TES-1631 (Ö-983 a) — reported by the lab beside the ordered analytes.
  egfr: "eGFR (njurfunktion)",
  total_cholesterol: "Totalkolesterol",
  ldl_hdl_ratio: "LDL/HDL-kvot",
};

/** The readable name, or the key itself for an analyte without one. */
export function labAnalyteName(analyteKey: string): string {
  return LAB_ANALYTE_NAMES[analyteKey] ?? analyteKey;
}
